/**
 * CustomerShell — Phase 2 chrome for the /dashboard/customer/* + /book*
 * + /booking/* route trees.
 *
 * Phase 3 §1 — accepts an optional `children` prop. When provided
 * (via `<PublicPageRouter>` for an authed customer viewing a public
 * route), renders that content in the main slot; otherwise mounts
 * the React Router `<Outlet>` for the customer sub-routes.
 *
 * No `<SharedNav>`, no `<SharedFooter>` — shells own their own top
 * region per Phase 2 Decision #6 + #18.
 */
import React from "react";
import { Outlet } from "react-router-dom";
import CustomerTopNav from "@/components/customer/CustomerTopNav";

export default function CustomerShell({ children }) {
  return (
    <div
      className="min-h-screen flex flex-col bg-pp-v3-bg"
      style={{ paddingTop: "var(--admin-mode-bar-h, 0px)" }}
      data-testid="customer-shell"
    >
      <CustomerTopNav />
      <main className="flex-1" data-testid="customer-shell-main">
        {children || <Outlet />}
      </main>
    </div>
  );
}
